module.exports = __webpack_public_path__ + "img/arrow-narrow-down-right.92178340.svg";